// extracted by mini-css-extract-plugin
export default {"root":"QzlWPEvX1D1zVE5DrGUQ","submit-button--remove":"fgEAf7hGALfURqYE2yNV"};